import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { DateService } from '../../shared/date.service';
import { DlgDeleteComponent } from '../dlg-delete/dlg-delete.component';
import { MatDialog } from '@angular/material/dialog';
import { TareaService } from '../../services/tarea.service';
import { ScnackbarData, ToastService, SnackbarStyles } from '../toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Anexo } from '../../models/Anexo';
import { AnexoService } from '../../services/anexo.service';
import { FilesService } from '../../shared/files.service';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { DlgAnexosTareaComponent } from '../dlg-anexos-tarea/dlg-anexos-tarea.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { DlgFirmaConjuntaCrearTareasComponent } from '../dlg-firma-conjunta-crear-tareas/dlg-firma-conjunta-crear-tareas.component';
import { NuevaTarea } from '../../models/Tarea';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AnexosSelectionService } from '../../services/anexos-selection.service';

@Component({
    selector: 'app-anexos-full',
    imports: [
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatMenuModule,
        MatTooltipModule,
        MatCheckboxModule
    ],
    templateUrl: './anexos-full.component.html',
    styleUrl: './anexos-full.component.scss'
})
export class AnexosFullComponent implements OnChanges {
  @Input() anexos!: Anexo[]
  @Input() tareas!: NuevaTarea[]
  @Input() idTarea!: any
  @Input() isScope!: boolean
  @Input() hasParticipated!: boolean
  @Input() isOwner!: boolean
  @Input() isEdit!: boolean
  @Input() isAddAnexo: boolean = false
  @Input() estadoTarea!: number
  @Output() successRefresh = new EventEmitter<boolean>()
  estadosPermitenBorrar = [-1, 0, 1]

  anexosOficios: Anexo[] = []
  anexosDocs: Anexo[] = []
  anexosMencionados: Set<number> = new Set<number>()

  snackbarData: ScnackbarData = {}

  constructor(
    private router: Router,
    private dateService: DateService,
    private dlg: MatDialog,
    private tareasService: TareaService,
    private toast: ToastService,
    private anexosService: AnexoService,
    private filesService: FilesService,
    private selectionService: AnexosSelectionService,
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["anexos"] && this.anexos) {
      this.anexosOficios = this.anexos.filter((anexo) => anexo.tipo === 0)
      this.anexosDocs = this.anexos.filter((anexo) => anexo.tipo === 1)

      const hasSavedSelection = this.selectionService.exists(this.idTarea);
      this.anexosMencionados = this.selectionService.get(this.idTarea);

      // Inicializa una sola vez: anexos de la tarea actual marcados por defecto.
      if (!hasSavedSelection) {
        const idTareaNum = Number(this.idTarea);
        this.anexos.forEach(anexo => {
          if (
            anexo.tarea === idTareaNum &&
            anexo.id != null &&
            anexo.tipo === 1
          ) {
            this.anexosMencionados.add(anexo.id);
          }
        });
        this.selectionService.set(this.idTarea, this.anexosMencionados);
      }
    }
  }

  openDlgAnexosFijo() {
    const dlgDestino = this.dlg.open(DlgAnexosTareaComponent, {
      panelClass: "anexos-panel",
      data: this.idTarea
    });

    dlgDestino.afterClosed().subscribe((result: Anexo[] | undefined) => {
      if (result !== undefined) {
        result.forEach((anexo) => {
          const exists = this.anexos.some(existingAnexo => existingAnexo.id === anexo.id);
          if (!exists) {
            this.anexos.push(anexo);
              // Si el anexo añadido pertenece a la tarea actual, mantenerlo marcado
              if (anexo.tarea === Number(this.idTarea)) {
                this.selectionService.add(this.idTarea, anexo.id!);
              }
          }
          this.anexosOficios = this.anexos.filter((anexo) => anexo.tipo === 0)
          this.anexosDocs = this.anexos.filter((anexo) => anexo.tipo === 1)
        });
      }
    });
  }

  showDeleteButton(): boolean{
    if(this.estadosPermitenBorrar.includes(this.estadoTarea)){
      return true
    }
    return false
  }

  onDeleteAnexo(id: number) {
    const dlgDelete = this.dlg.open(DlgDeleteComponent, {
      width: '350px',
    });

    dlgDelete.afterClosed().subscribe(result => {
      if (result === 1) {
        this.tareasService.deleteAnexoTarea(id).subscribe({
          next: (_) => {
            this.anexos = this.anexos.filter((anexo) => anexo.id !== id);
            this.anexosDocs = this.anexosDocs.filter((anexo) => anexo.id !== id);
            this.selectionService.delete(this.idTarea, id);
            this.snackbarData.message = "Anexo eliminado!"
            this.snackbarData.style = SnackbarStyles.Success
            this.toast.show(this.snackbarData)
          }
        })
      }
    });
  }

  openAnexo(anexoID: number) {
    const anexoType = this.anexos.find((anexo) => anexo.id === anexoID)?.estatus
    this.anexosService.getAnexoByID(anexoID, anexoType!).subscribe({
      next: (response) => {
        this.filesService.openFileFromOctectStream(response)
      },
      error: (error) => {
        console.error('Error downloading the anexo', error);
      }
    });
  }

  downloadAnexo(anexoID: number) {
    const anexoType = this.anexos.find((anexo) => anexo.id === anexoID)?.estatus
    this.anexosService.getAnexoByID(anexoID, anexoType!).subscribe({
      next: (response) => {
        this.filesService.openFileFromOctectStream(response, true)
      },
      error: (error) => {
        console.error('Error downloading the anexo', error);
      }
    });
  }

  openDlgSignAnexo(anexoID: number) {
    this.router.navigateByUrl(`/firmarAnexo/${this.idTarea}/${anexoID}/${this.isEdit ? "finalizar" : "resumen"}`)
  }

  onMultipleSign(anexoID: number) {
    const dialogRef = this.dlg.open(DlgFirmaConjuntaCrearTareasComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: {idTarea: this.idTarea, idAnexo: anexoID}
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.successRefresh.emit(true)
      }
    });
  }

  onEditAnexoMemo(anexoID: number) {
    this.router.navigateByUrl(`/editar/redactar/${anexoID}`)
  }

  checkAnexoPDF(anexoID: number) {
    const name = this.anexos.find((anexo) => anexo.id === anexoID)?.nombre
    const extension = name?.slice(name.length - 3, name.length)
    if (extension === "pdf") {
      return true
    }
    return false
  }

  getNombreAdjunto(anexo: any){
    return (anexo.observacion)? anexo.observacion : anexo.nombre;
  }

  checkFirmaConjunta(tarea: NuevaTarea): boolean{
    return tarea!.conjunta == 1;
  }

  redactar() {
    const taskData = {
      documentIDs: [parseInt(this.idTarea)]
    }
    this.router.navigateByUrl("/redactar/"+this.idTarea, { state: taskData })
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date!)
  }

  toggleAnexoMencionado(anexoId: number, checked: boolean): void {
    if (checked) {
      this.anexosMencionados.add(anexoId);
      this.selectionService.add(this.idTarea, anexoId);
    } else {
      this.anexosMencionados.delete(anexoId);
      this.selectionService.delete(this.idTarea, anexoId);
    }
  }

  isAnexoMencionado(anexoId: number): boolean {
    return this.anexosMencionados.has(anexoId);
  }

  getAnexosMencionadosIds(): number[] {
    return Array.from(this.anexosMencionados)
      .filter(id => this.anexos.some(a => a.id === id && a.tipo === 1));
  }

  /**
   * Verifica si un anexo pertenece a la tarea actual
   */
  isAnexoDeTareaActual(anexo: Anexo): boolean {
    return anexo.tarea === Number(this.idTarea);
  }
}
